var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10089",
    "data-name": "Group 10089",
    transform: "translate(-16428 -832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "android-refresh",
    d: "M17.625,26.625a9,9,0,1,0,0-18,8.72,8.72,0,0,0-6.3,2.7l3.452,4.189-9.152.611V5.625L9.15,9.15A11.985,11.985,0,1,1,6.075,20.9H9.249A8.937,8.937,0,0,0,17.625,26.625Z",
    transform: "translate(16422.375 826.375)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M18.3,10.512H16.5V17.7l6.29,3.774.9-1.5L18.3,16.8Z",
    transform: "translate(16422.281 828.007)",
    fill: "#8a8a8a",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeGray);
export default __webpack_public_path__ + "static/media/time_gray.e01efe4429cf04029a2a4f2ee7a43497.svg";
export { ForwardRef as ReactComponent };